import styled from 'styled-components';

const DesignerLinkWrapper = styled.div`
  padding: 7px;
`;

export default DesignerLinkWrapper;
